import { useNavigate } from 'react-router-dom'
import { Table, Input, Label } from 'reactstrap'
import OperatorInput from '../OperatorInput'
import useForm from '../../CustomHooks/FormHook'
import '../Custom.css'
import CustomSelectListInput from '../CustomSelectListInput'
import { initialFormValues, submitFormValues } from '../CustomUtils'
import { enterKeyHandler } from '../../../utils'
import FormSubmitButton from '../FormSubmitButton'
import DateRangeInput from '../DateRangeInput'
import FormHeading from '../FormHeading'
import TextInput from '../TextInput'

export default function LetterSearchForm() {
  console.log('LetterSearchForm rendered')

  let initialInputs = {
    operator: 'C',
    company: '',
    noCompany: null,
    location: '',
    noLocation: null,
    contract: '',
    letterType: '',
    plaintiff: '',
    dateFrom: '',
    dateTo: '',
  }

  const navigate = useNavigate()
  initialInputs = initialFormValues('LetterSearchForm', navigate, initialInputs)
  const { inputs, handleInputChange, handleSubmit } = useForm(initialInputs, submitSearch, enterKeyHandler(submitSearch))

  async function submitSearch() {
    inputs.noCompany = (inputs.noCompany === 'on' || inputs.noLocation === 'Y') ? 'Y' : ''
    inputs.noLocation = (inputs.noLocation === 'on' || inputs.noLocation === 'Y') ? 'Y' : ''
    submitFormValues('LetterSearchForm', navigate, inputs, 'fwcontracts.letter_search')
  }

  return (
    <div className="custom-scroll">
      <form className="form" onSubmit={handleSubmit}>
        <FormSubmitButton label='Search' />
        <div>
          <Table bordered className="custom-table custom-form-table">
            <FormHeading headingText='Contract and Production Transmittal Letters Search' />
            <tbody>
              <tr >
                <td><Label><b>Company/Site/Vessel</b></Label></td>
                <td><OperatorInput handleChange={handleInputChange} defaultValue={inputs.operator} />
                  <Input className="custom-input" size="50" name="company" onChange={handleInputChange} defaultValue={inputs.company} />
                  <Input className="custom-checkbox" type="checkbox" name="noCompany" onChange={handleInputChange} defaultChecked={inputs.noCompany} /><span> No Company Specified</span>
                  <span><br /><br /></span><b>Note:</b> This field searches the "Company/Site/Vessel" text and the "Station, Refinery, Mill, Etc." text.
                </td>
              </tr>
              <tr>
                <td><Label><b>Location</b></Label></td>
                <td>
                  <Input className="custom-input" size="50" name="location" onChange={handleInputChange} defaultValue={inputs.location} />
                  <Input className="custom-checkbox" type="checkbox" name="noLocation" onChange={handleInputChange} defaultChecked={inputs.noLocation} /><span> No Location Specified</span>
                </td>
              </tr>
              <TextInput label='Overall Contract Number' name='contract' handleInputChange={handleInputChange} defaultValue={inputs.contract} />
              <CustomSelectListInput label="Contract Letter Type" style={{ display: 'inline-block', width: 'auto', marginRight: '5px', marginLeft: '5px' }} handleChange={handleInputChange} name='letterType' multiple={false} modelName='Custom' entityName="letter_type" defaultValue={inputs.letterType} />
              <DateRangeInput label='Date' name='date' handleInputChange={handleInputChange} defaultValueFrom={inputs.dateFrom} defaultValueTo={inputs.dateTo} />
              <TextInput label='Plaintiff' name='plaintiff' handleInputChange={handleInputChange} defaultValue={inputs.plaintiff} />
            </tbody>
          </Table>
        </div>
        <FormSubmitButton label='Search' />
      </form>
    </div>
  )
}